import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios"

import { defaultAxiosInstance } from "./client"
import { ResponseData, PmcDataType } from "./common"

export interface HostPmcResponseDataData extends ResponseData {
  content: PmcDataType[]
  pageable: {
    sort: {
      empty: boolean
      sorted: boolean
      unsorted: boolean
    }
    offset: number
    pageNumber: number
    pageSize: number
    paged: boolean
    unpaged: boolean
  }
  last: boolean
  totalPages: number
  totalElements: number
  number: number
  sort: {
    empty: boolean
    sorted: boolean
    unsorted: boolean
  }
  size: number
  first: boolean
  numberOfElements: number
  empty: boolean
}

export interface HostPmcResponseData extends ResponseData {
  data: HostPmcResponseDataData
}

export interface HostPmcResponse extends AxiosResponse {
  data: HostPmcResponseData
  fromPmcHeaderDropdown: boolean
}

export const defaultUrl = `${process.env.REACT_APP_BASE_API_URL || ""}/host/pmc`

export interface HostPmcParamsType {
  keyword: string
  pageNo: number
  noOfRecords: number
  sortDirection: string
  sortBy: string
  searchFirstByPmcId?: string | null
}

export interface HostPmcParamsRequest extends Partial<AxiosRequestConfig> {
  params: HostPmcParamsType
  fromPmcHeaderDropdown?: boolean
}

export function getHostPmc(
  { params }: HostPmcParamsRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<HostPmcResponse> {
  return axiosInstance({
    params,
    method: "get",
    url: defaultUrl,
  }) as Promise<HostPmcResponse>
}

const getAdminPmcURL = `${process.env.REACT_APP_BASE_API_URL || ""}/admin/pmc`

export function getAdminPmc(
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<HostPmcResponse> {
  return axiosInstance({
    method: "get",
    url: getAdminPmcURL,
  }) as Promise<HostPmcResponse>
}
